import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAsp from 'hooks/useAsp';

declare global {
  interface Window {
    a8sales?: (params: unknown) => void;
  }
}

const A8netTag = () => {
  const { isThanks, order } = useAsp();
  const { pathname } = useLocation();

  useEffect(() => {
    const loadScriptId = 'a8net-load1';
    const scriptId = 'a8net';

    const fireA8 = () => {
      if (!isThanks || !order || typeof window.a8sales !== 'function') return;

      const { order_code: orderCode = '', billing_amount = 0, tax_amount = 0 } = order;
      const price = billing_amount + tax_amount;

      // 二重発火防止
      const firedKey = `a8-fired-${orderCode}`;
      if (sessionStorage.getItem(firedKey)) return;
      sessionStorage.setItem(firedKey, '1');

      window.a8sales({
        pid: 's00000016921003',
        order_number: orderCode,
        currency: 'JPY',
        items: [
          {
            code: 'a8',
            price,
            quantity: 1
          }
        ],
        total_price: price
      });
    };

    let loadScript = document.getElementById(loadScriptId) as HTMLScriptElement | null;

    if (!loadScript) {
      loadScript = document.createElement('script');
      loadScript.src = 'https://statics.a8.net/a8sales/a8sales.js';
      loadScript.id = loadScriptId;
      loadScript.async = true;
      loadScript.onload = () => {
        fireA8();
      };
      document.head.appendChild(loadScript);
    } else if (typeof window.a8sales === 'function') {
      fireA8();
    } else {
      loadScript.onload = () => {
        fireA8();
      };
    }

    return () => {
      const inlineScript = document.getElementById(scriptId);
      if (inlineScript) inlineScript.remove();
    };
  }, [pathname, isThanks, order]);

  return isThanks ? <span id="a8sales" /> : null;
};

export default A8netTag;
